module.exports = __webpack_public_path__ + "static/media/Purpose_40.d9fed512.png";